import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import Vuelidate from 'vuelidate'
import vSelect from 'vue-select'
import store from './store'
import VueNotifications from 'vue-notifications'
import iziToast from 'izitoast'
import EasySlider from 'vue-easy-slider'
import VModal from 'vue-js-modal'
import TCloseModal from './components/TCloseModal'
import TButton from './components/TButton'
// https://github.com/dolce/iziToast
import VueTheMask from 'vue-the-mask'
// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import 'izitoast/dist/css/iziToast.min.css'
import './assets/css/grid.css'
import './assets/css/layout.css'
import '@fortawesome/fontawesome-free/css/all.css'
import vuetify from './plugins/vuetify'
import VueHtml2Canvas from '@/mixins/html-2-canvas.js'
import Vlf from 'vlf'
import localforage from 'localforage'
import VueYoutube from 'vue-youtube'

const messageSize = 20
const titleSize = 22
const timeout = 8000
const messageLineHeight = 22
const titleLineHeight = 22
// eslint-disable-next-line
function toast({ title, message, position, type, cb }) {
  if (type === VueNotifications.types.warn) type = 'warning'
  return iziToast[type]({ title, titleSize, message, position, messageSize, messageLineHeight, titleLineHeight, timeout })
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

Vue.use(VueNotifications, options)
Vue.use(Vuelidate)
Vue.use(VueYoutube)
Vue.use(EasySlider)
Vue.use(VModal)
Vue.use(VueTheMask)
Vue.component('t-close-modal', TCloseModal)
Vue.component('t-button', TButton)
Vue.component('v-select', vSelect)
Vue.use(VueHtml2Canvas)
Vue.use(Vlf, localforage)

Vue.config.productionTip = false
localforage.createInstance({
  storeName: 'travessia'
})

localforage.config({
  driver: localforage.INDEXEDDB, // Force WebSQL; same as using setDriver()
  name: 'travessia-online',
  version: 1.0,
  size: 4980736, // Size of database, in bytes. WebSQL-only for now.
  storeName: 'travessia', // Should be alphanumeric, with underscores.
  description: 'Banco de dados'
})

new Vue({
  router,
  store,
  vuetify,
  mode: 'history',
  render: h => h(App)
}).$mount('#app')
